import SkillsBox from './SkillsBox';

export default SkillsBox;
export { SkillsBox };
